import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import {
  getInfulencerWithdrawalsList,
  updateInfluencerWithdrawReq,
} from "../../../../store/affiliate/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";

const InfluencerWithdraw = () => {
  const dispatch = useDispatch();
  const [pageSize] = useState(10);
  const { InfluencerWithdrawList, loading, totalCount } = useSelector(
    (state) => state.AffiliateContent,
  );

  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [filter, setFilter] = useState({
    status: "pending",
    page: 1,
    limit: pageSize,
    search: "",
  });

  const hasFetched = useRef(false);

  const fetchData = () => {
    try {
      const callback = (err, res) => {
        if (err) toast.error(err);
      };
      dispatch(getInfulencerWithdrawalsList({ data: filter, callback }));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedStatus !== filter.status) {
      setFilter((prev) => ({ ...prev, status: selectedStatus, page: 1 }));
    }
  }, [selectedStatus]);

  useEffect(() => {
    if (hasFetched.current) {
      fetchData();
    }
  }, [filter]);

  const handleApproveClick = (item) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success(res.message || "Request approved successfully");
        }
      };

      dispatch(
        updateInfluencerWithdrawReq({
          id: item?._id,
          data: {
            status: "approved",
            adminNotes: "Approved by admin",
          },
          callback,
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleRejectClick = (item) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success(res.message || "Request rejected successfully");
        }
      };
      dispatch(
        updateInfluencerWithdrawReq({
          id: item?._id,
          data: {
            status: "rejected",
            adminNotes: "Rejected by admin",
          },
          callback,
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, page: page.selected + 1 }));
  };

  const ApproveIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M13.485 1.929a.75.75 0 0 1 1.06 1.06l-8 8a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06L6 9.44l7.485-7.51z" />
    </svg>
  );

  const RejectIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );

  const column = [
    {
      head: "Sr No",
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span className="text-capitalize cursor-pointer">
          {(filter.page - 1) * pageSize + (ind + 1)}
        </span>
      ),
    },
    {
      head: "Email Address",
      accessor: "email",
      isComponent: true,
      component: (item) => (
        <span className="text">{item?.influencerId?.email}</span>
      ),
    },
    {
      head: "Payment Method",
      accessor: "paymentMethod",
      isComponent: true,
      component: (item) => (
        <div className="content">
          <p className="m-0 text-muted text-capitalize">
            {item?.paymentDetails?.method || "NA"}
          </p>
        </div>
      ),
    },
    {
      head: "Amount (In USD)",
      accessor: "amount",
      isComponent: true,
      component: (item) => (
        <div className="content">
          <p className="m-0 text-muted text-capitalize">
            {item?.amountUsd || "NA"}
          </p>
        </div>
      ),
    },
    {
      head: "Created At",
      accessor: "createdAt",
      isComponent: true,
      component: (item) => (
        <span className="text">
          {moment(item?.createdAt).format("YYYY-MM-DD")}
        </span>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      isComponent: true,
      component: (item) => (
        <p
          className={`${
            item.status === "pending"
              ? "yellowStatus"
              : item.status === "rejected"
                ? "redStatus"
                : item.status === "approved"
                  ? "greenStatus"
                  : ""
          } status text-capitalize m-0 d-flex justify-content-center align-item-center rounded-pill px-3 py-1`}
        >
          {item.status}
        </p>
      ),
    },
    {
      head: "Tokens",
      accessor: "token",
      isComponent: true,
      component: (item) => {
        return (
          <span className="text fw-sbold">{item?.amountTokens || "NA"}</span>
        );
      },
    },
    {
      head: "Actions",
      accessor: "",
      isComponent: true,
      component: (item) => {
        const status = item.status;

        return (
          <div className="ActnBtn d-flex align-items-center gap-10">
            <div className="d-flex gap-2">
              {status === "pending" && (
                <>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => handleApproveClick(item)}
                    title="Approve"
                  >
                    <ApproveIcon />
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRejectClick(item)}
                    title="Reject"
                  >
                    <RejectIcon />
                  </Button>
                </>
              )}

              {status === "approved" && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  // onClick={() => handleRejectClick(item)}
                  title="Reject"
                >
                  <RejectIcon />
                </Button>
              )}

              {status === "rejected" && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  // onClick={() => handleApproveClick(item)}
                  title="Re-approve"
                >
                  <ApproveIcon />
                </Button>
              )}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}

      <section className="ManageTeacher position-relative">
        <Container>
          <div className="pb-2 cardCstm">
            <Row className="px-3 py-2 bg-white align-items-center">
              <Col lg="12" className="my-2 px-0">
                <div className="px-3 d-flex align-items-center justify-content-between gap-10">
                  <h5 className="mb-0 py-3 fw-sbold text-capitalize px-3">
                    Influencer Withdrawals
                  </h5>
                </div>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Control
                  type="text"
                  name="search"
                  value={filter.search || ""}
                  placeholder="Search using name or email"
                  onChange={(e) =>
                    setFilter((prev) => ({
                      ...prev,
                      search: e.target.value,
                      page: 1,
                    }))
                  }
                />
              </Col>
              <Col md={3} className="mb-3">
                <Form.Select
                  className="p-2"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </Form.Select>
              </Col>
            </Row>
          </div>

          <Row>
            {!loading && (
              <Col lg="12" className="mx-0">
                <div className="cardCstm p-3 rounded bg-white">
                  {InfluencerWithdrawList?.length > 0 ? (
                    <TableLayout
                      data={InfluencerWithdrawList}
                      column={column}
                      totalCount={totalCount}
                      limit={filter.limit}
                      loading={loading}
                      handlePageChange={handlePageChange}
                      pageNo={filter.page}
                      status={"status"}
                    />
                  ) : (
                    <div className="d-flex justify-content-center">
                      <p>No Data Found</p>
                    </div>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default InfluencerWithdraw;
